/**
 * Canonical locale codes (BCP 47) for Zynea UI.
 * Used by LangSwitcher, UpdateLocaleForm, i18n.js and backend SetLocale.
 */
export const SUPPORTED_LOCALES = [
    'es',
    'en',
    'pt-BR',
    'de',
    'fr',
    'ja',
    'ko',
    'zh-CN',
];

/** @type {{ code: string; labelKey: string; nativeLabel: string; flag: string }[]} */
export const LANGUAGE_OPTIONS = [
    { code: 'es', labelKey: 'navbar.languages.es', nativeLabel: 'Español', flag: '🇪🇸' },
    { code: 'en', labelKey: 'navbar.languages.en', nativeLabel: 'English', flag: '🇬🇧' },
    { code: 'pt-BR', labelKey: 'navbar.languages.ptBR', nativeLabel: 'Português', flag: '🇧🇷' },
    { code: 'de', labelKey: 'navbar.languages.de', nativeLabel: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', labelKey: 'navbar.languages.fr', nativeLabel: 'Français', flag: '🇫🇷' },
    { code: 'ja', labelKey: 'navbar.languages.ja', nativeLabel: '日本語', flag: '🇯🇵' },
    { code: 'ko', labelKey: 'navbar.languages.ko', nativeLabel: '한국어', flag: '🇰🇷' },
    { code: 'zh-CN', labelKey: 'navbar.languages.zhCN', nativeLabel: '简体中文', flag: '🇨🇳' },
];

/** Normalize browser/cookie/user locale to a supported code. */
export function normalizeLocaleCode(raw) {
    if (!raw || typeof raw !== 'string') return null;
    const tag = raw.trim().replace(/_/g, '-');
    const lower = tag.toLowerCase();

    if (lower === 'pt' || lower === 'pt-br') return 'pt-BR';
    if (lower === 'zh' || lower === 'zh-cn' || lower === 'zh-hans') return 'zh-CN';
    if (lower.startsWith('en')) return 'en';
    if (lower.startsWith('es')) return 'es';
    if (lower.startsWith('de')) return 'de';
    if (lower.startsWith('fr')) return 'fr';
    if (lower.startsWith('ja')) return 'ja';
    if (lower.startsWith('ko')) return 'ko';

    const exact = SUPPORTED_LOCALES.find((code) => code.toLowerCase() === lower);
    return exact ?? null;
}

export function isSupportedLocale(code) {
    return normalizeLocaleCode(code) !== null;
}
